import { MessagingChannelFeature } from '@whatsper/texterchat-common';
import classnames from 'classnames';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip, message } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store/rootStore';
import { formatPhone } from '../../Base/Phone/Formatter';
import s from './ChatIdInfo.module.scss';
import { getDirection } from '../../../helpers';
const NO_ID_FALLBACK = '---';
function ChatIdInfo({ chat, className, inverted, }) {
    var _a;
    const { t } = useTranslation();
    const { phoneFormat, defaultCountry, channels } = useStore(), [idFormatted, setIdFormatted] = useState(NO_ID_FALLBACK), [copyText, setCopyText] = useState(''), [accountName, setAccountName] = useState('');
    const isClipboardSupported = typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) === 'function';
    const isRtl = getDirection() === 'rtl';
    useEffect(() => {
        const adapter = channels.adaptersByAccountId[`${chat.channelInfo.name}${chat.channelInfo.accountId}`];
        if (adapter) {
            if (channels.hasFeatures([MessagingChannelFeature.contactPhoneNumberId], adapter)) {
                const formattedPhone = formatPhone(chat.channelInfo.id, phoneFormat, defaultCountry);
                setIdFormatted(formattedPhone);
                setCopyText(formattedPhone.replace(/-/g, '')); // replace dashes for copy
            }
            else if (channels.hasFeatures([MessagingChannelFeature.contactGlobalId], adapter)) {
                setIdFormatted(chat.channelInfo.id);
                setCopyText(chat.channelInfo.id);
            }
            else {
                setIdFormatted(NO_ID_FALLBACK);
            }
        }
        else {
            setIdFormatted(chat.channelInfo.id);
            setCopyText(chat.channelInfo.id);
        }
    }, [chat._id, channels.adaptersByAccountId, phoneFormat, defaultCountry]);
    useEffect(() => {
        var _a;
        const account = channels.accountsById[`${chat.channelInfo.name}${chat.channelInfo.accountId}`];
        if (account) {
            setAccountName(account.title || ((_a = account.metadata) === null || _a === void 0 ? void 0 : _a.accountTitle) || account.accountId);
        }
    }, [chat._id, channels.accountsById]);
    const handleCopy = () => {
        if (isClipboardSupported) {
            navigator.clipboard.writeText(copyText)
                .then(() => {
                message.success(t('phoneCopiedToClipboard'));
            })
                .catch((err) => {
                message.error(t('failedToCopy'));
            });
        }
    };
    return (React.createElement("div", { className: classnames(s.container, className, {
            [s.inverted]: inverted,
        }) },
        React.createElement("div", { className: s.userInfoPhone },
            idFormatted,
            idFormatted !== NO_ID_FALLBACK && isClipboardSupported && (React.createElement(Tooltip, { title: t("copyToClipboard") },
                React.createElement(CopyOutlined, { className: classnames(s.copyIcon, { [s.rtl]: isRtl }), onClick: handleCopy })))),
        React.createElement("div", null, "|"),
        accountName && React.createElement("div", { className: s.accountName }, accountName)));
}
/**
 * Component to display chat formatted ID and channel account title
 */
export default observer(ChatIdInfo);
